import { parseLocale } from 'hooks';
import { $fetch } from 'utils/request';
import { ENRICHMENT_TWS, TWS_EVENT_CONDITIONS, TWS_EVENT_SUBSCRIBE, TWS_EVENT_UNSUBSCRIBE } from 'utils/routes';

type TTwsEvent = {
  eventId: number;
  email: string;
  profile: string;
};

type TSubscribeTwsEvent = TTwsEvent & {
  name: string;
  phonePrefix: string;
  phone: string;
  lab: boolean;
};

type TConditionsTwsEventResponse = {
  urlTc: string;
  translations?: {
    share: string;
    title: string;
    titleNotMember: string;
    subtitle: string;
    subtitleNotMember: string;
    extraInfo: string;
    subscribe: string;
    unsubscribe: string;
    unsubscribeConfirm: string;
    unsubscribeConfirmText: string;
  };
};

type TConditionsTwsEvent = {
  profile: string;
  eventId: string;
};

export async function conditionsTwsEvent(searchParams: TConditionsTwsEvent) {
  const { language } = parseLocale(searchParams.profile);
  const data = await $fetch<TConditionsTwsEventResponse>({
    path: `${TWS_EVENT_CONDITIONS}`,
    query: searchParams,
  });
  let eventConditionsUrl = data.urlTc;

  if (eventConditionsUrl && eventConditionsUrl.includes('{lang}')) {
    eventConditionsUrl = eventConditionsUrl.replace('{lang}', language.toUpperCase());
  }
  return {
    url: eventConditionsUrl,
    translations: data.translations ?? null,
  };
}

export async function subscribeTwsEvent(data: TSubscribeTwsEvent) {
  return await $fetch<{ message?: string }>(
    {
      path: TWS_EVENT_SUBSCRIBE,
    },
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
  );
}

export async function unsubscribeTwsEvent(data: TTwsEvent) {
  return await $fetch(
    {
      path: TWS_EVENT_UNSUBSCRIBE,
    },
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
  );
}

type TEnrichTwsEvent = {
  profile: string;
  payload: Record<string, any>;
};

export async function enrichTwsEvent({ profile, payload }: TEnrichTwsEvent) {
  return await $fetch(
    {
      path: ENRICHMENT_TWS,
    },
    {
      method: 'POST',
      body: JSON.stringify({ profile, ...payload }),
    },
  );
}
